
/**
 * Formats a numeric value according to the specified locale and decimal places.
 *
 * @param value The numeric value to format.
 * @param decimalPlaces The maximum number of decimal places to display (default is 2).
 * @param minDecimalPlaces The minimum number of decimal places to display (optional).
 * @param locales The locale(s) to use for formatting (optional).
 * @returns The formatted number as a string, or an empty string if the value is null or not a number.
 */
export function isgNumericLocale(
  value: number,
  decimalPlaces: number = 2,
  minDecimalPlaces: number | undefined = undefined,
  locales: string | string[] | undefined = undefined
): string {

  if (value != null && !isNaN(value)) {

    // Format the number with up to the maximum decimal places
    let formattedValue = new Intl.NumberFormat(locales, {
      minimumFractionDigits: (minDecimalPlaces) ? minDecimalPlaces : decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(value);

    return formattedValue;

  } else {
    return "";
  }
}


